import React from "react"
import { Box, Stack, Link, Text } from "@chakra-ui/react"
import { NavLink } from "react-router-dom"

const Sidebar = () => {
  return (
    <Box
      width="250px"
      padding="4"
      borderRightWidth="1px"
      borderColor="gray.200"
      bg="gray.50"
      height="100vh" // Make the sidebar full height
    >
      <Text fontSize="2xl" mb={4}>
        Navigation
      </Text>
      <Stack spacing={3}>
        <Link
          as={NavLink}
          to="/"
          p={2} // Padding for better click area
          borderRadius="md" // Rounded corners
          _hover={{ bg: "teal.100", color: "teal.800" }} // Hover effect
          _active={{ bg: "teal.200" }} // Active effect
        >
          Home
        </Link>
        <Link as={NavLink} to="/swap" p={2} borderRadius="md" _hover={{ bg: "teal.100", color: "teal.800" }} _active={{ bg: "teal.200" }}>
          Swap
        </Link>
        <Link as={NavLink} to="/info" p={2} borderRadius="md" _hover={{ bg: "teal.100", color: "teal.800" }} _active={{ bg: "teal.200" }}>
          Info
        </Link>
        <Link
          as={NavLink}
          to="/publicKeys"
          p={2}
          borderRadius="md"
          _hover={{ bg: "teal.100", color: "teal.800" }}
          _active={{ bg: "teal.200" }}
        >
          Public Keys
        </Link>
      </Stack>
    </Box>
  )
}

export default Sidebar
